import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

const def = 'https://coursalytics.com/static/images/og_cover.png';

const Image = ({ content }) => (
  <Head>
    <meta property="og:image" content={content} />
    {(content !== def) && (
      <>
        <meta property="og:image:height" content="630" />
        <meta property="og:image:width" content="1200" />
      </>
    )}
  </Head>
);

Image.propTypes = {
  content: PropTypes.string,
};

Image.defaultProps = {
  content: def,
};

export default Image;
